import { render, staticRenderFns } from "./FeatureControl.vue?vue&type=template&id=d503c456&scoped=true"
import script from "./FeatureControl.vue?vue&type=script&lang=js"
export * from "./FeatureControl.vue?vue&type=script&lang=js"
import style0 from "./FeatureControl.vue?vue&type=style&index=0&id=d503c456&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d503c456",
  null
  
)

export default component.exports